import axiosInstance from "../utils/authUtils";
import { API_PATHS ,API_BASE_URL} from "../utils/constants/api.constants";

class AirportCarPriceService {


  static getairportCarCharges(item) {
  
      let api = '';
      if(item?.id){
         api= `${API_BASE_URL}${API_PATHS.getairportCarCharges}?id=${item?.id}`
      }
       else{
      api = `${API_BASE_URL}${API_PATHS.getairportCarCharges}?limit=${item?.limit}`;
      }
      return axiosInstance
          .get(api)
          
  }




  
static addairportCarCharges(item) {
  
    let api = '';
    api = `${API_BASE_URL}${API_PATHS.addairportCarCharges}`;
    return axiosInstance
        .post(api,item)
        
}

static editairportCarCharges(item) {
  
    let api = '';
    api = `${API_BASE_URL}${API_PATHS.editairportCarCharges}`;
    return axiosInstance
        .put(api,item)
        
}

static deleteairportCarCharges(item) {
  
    let api = '';
    if(item?.id){
        api = `${API_BASE_URL}${API_PATHS.deleteairportCarCharges}?id=${item?.id}`;
    }else{
        api = `${API_BASE_URL}${API_PATHS.deleteairportCarCharges}`;
    }
    
    return axiosInstance
        .delete(api)
        
}


  
}

export default AirportCarPriceService;